import React, { FC } from 'react';
import ConsultantFormV3 from '@/src/components/feature/ConsultantForm/ConsultantFormV3';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const ContactUs: FC = () => {
  return <ConsultantFormV3 />;
};

export default ContactUs;

export const getStaticProps = async ({ locale }: { locale: string }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};
